const RELOAD_ATTEMPT_KEY = "extremeb2b:chunk-reload-attempted-at";
const RELOAD_THROTTLE_MS = 60 * 1000;

const CHUNK_LOAD_ERROR_PATTERNS = [
  /ChunkLoadError/i,
  /Loading chunk \d+ failed/i,
  /CSS_CHUNK_LOAD_FAILED/i,
  /Failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /Importing a module script failed/i,
];

const getErrorText = (error) => {
  if (!error) {
    return "";
  }

  if (typeof error === "string") {
    return error;
  }

  const reason = error.reason || error.error || error;
  const message = reason.message || error.message || "";
  const stack = reason.stack || error.stack || "";
  const filename = error.filename || "";

  return `${message} ${stack} ${filename}`;
};

export const isChunkLoadError = (error) => {
  const errorText = getErrorText(error);

  return CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => pattern.test(errorText));
};

const hasRecentReloadAttempt = () => {
  const attemptedAt = Number(sessionStorage.getItem(RELOAD_ATTEMPT_KEY));

  return Number.isFinite(attemptedAt) && Date.now() - attemptedAt < RELOAD_THROTTLE_MS;
};

export const clearStaleBrowserCaches = async () => {
  if ("serviceWorker" in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((registration) => registration.unregister()));
  }

  if ("caches" in window) {
    const cacheNames = await window.caches.keys();
    await Promise.all(cacheNames.map((cacheName) => window.caches.delete(cacheName)));
  }
};

export const reloadOnChunkLoadError = (error) => {
  if (!isChunkLoadError(error) || hasRecentReloadAttempt()) {
    return false;
  }

  sessionStorage.setItem(RELOAD_ATTEMPT_KEY, String(Date.now()));

  clearStaleBrowserCaches().finally(() => {
    window.location.reload();
  });

  return true;
};
